import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isAtsEmbedActive } from '@/hoc/api/ats-embed';
/** Keep in sync with the inline loader in public/index.html. */
export function isMarketingPage(pathname, isLoggedIn) {
    const path = pathname.replace(/\/+$/, '') || '/';
    // '/' is the landing for everyone except a signed-in ATS embed (the dashboard).
    if (path === '/')
        return !(isLoggedIn && isAtsEmbedActive());
    return (path === '/ai-interview' ||
        path === '/ai-interview/about' ||
        path === '/ai-interview/contact' ||
        path === '/careers' ||
        path === '/career-guide' ||
        path === '/overview' ||
        path === '/privacy-policy' ||
        path === '/terms-of-use' ||
        path === '/blog' ||
        path.startsWith('/blog/'));
}
export function useAppBundles(isLoggedIn) {
    const { pathname } = useLocation();
    useEffect(() => {
        var _a;
        if (!isMarketingPage(pathname, isLoggedIn))
            (_a = window.__loadAppBundles) === null || _a === void 0 ? void 0 : _a.call(window);
    }, [pathname, isLoggedIn]);
}
